import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

type MaxWidth = "5xl" | "none";

const MAX_WIDTH_CLASSES: Record<MaxWidth, string> = {
  "5xl": "max-w-5xl",
  none: "",
};

export const ChatListContainer: FC<{
  children: ReactNode;
}> = ({ children }) => <div className="bg-slate-50 p-6">{children}</div>;

export const ChatList: FC<{
  children: ReactNode;
  maxWidth?: MaxWidth;
  centered?: boolean;
}> = ({ children, maxWidth = "none", centered = false }) => (
  <div
    className={clsx(
      "flex flex-col gap-8",
      MAX_WIDTH_CLASSES[maxWidth],
      centered && "mx-auto",
    )}
  >
    {children}
  </div>
);
